import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=39078384&scoped=true&"
import script from "./Recommend.vue?vue&type=script&lang=js&"
export * from "./Recommend.vue?vue&type=script&lang=js&"
import style0 from "./Recommend.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=39078384&scoped=true&lang=css&"
import style2 from "./Recommend.vue?vue&type=style&index=2&id=39078384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39078384",
  null
  
)

export default component.exports